// Cross-section lead intent, shared by every site.
//
// Most visitors arrive with a problem and let the site work out whether it's
// a repair or a replacement. Some already know — they've had the diagnosis,
// the unit is 20 years old, they just want somebody out to quote a new
// system. That visitor is a different (and much stronger) lead, so every
// site has a button that says so, and the contact form adapts around it.
//
// `null` means the visitor hasn't said. That's deliberately NOT the same as
// "repair": the backend derives the type from the evidence in that case,
// and records that it inferred rather than being told.
import { ref } from 'vue'
import type { LeadType } from '@/shared/api/types'

export const leadIntent = ref<LeadType | null>(null)

/** The "I already know I need a replacement" button: declare the intent and
 * send the visitor to the contact section, which opens the optional details
 * for them. */
export function declareReplacement(sectionId: string) {
    leadIntent.value = 'replace'
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' })
}
